import { Chart, registerables } from 'chart.js';
import palette from '../../theme/palette';

export const getCanvaBarChart = (
  QuizRecapData: any,
  canvas: CanvasRenderingContext2D
) => {
  Chart.register(...registerables);
  const data = {
    labels: QuizRecapData.labels,
    datasets: [
      {
        label: 'Bonnes réponses',
        data: QuizRecapData.goodAnswers,
        borderColor: palette.common.green,
        backgroundColor: palette.common.green,
        borderWidth: 2,
        borderRadius: 5
      },
      {
        label: 'Mauvaises réponses',
        data: QuizRecapData.wrongAnswers,
        borderColor: palette.common.red,
        backgroundColor: palette.common.red,
        borderWidth: 2,
        borderRadius: 5
      }
    ]
  };
  return new Chart(canvas, {
    type: 'bar',
    data: data,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      indexAxis: 'y',
      scales: {
        x: {
          stacked: true,
          beginAtZero: true,
          max: QuizRecapData.nbStudents,
          ticks: {
            stepSize: 1
          }
        },
        y: {
          beginAtZero: true,
          stacked: true
        }
      }
    }
  });
};
